import { isProRoute } from 'assets/routes/proRoutes';

// Filtra el menú por userType y por plan: oculta items cuyo route es Pro
// cuando el tenant es lite.
export function filterMenuItems(menu, userType, plan) {
  if (!Array.isArray(menu)) return [];
  return menu
    .filter((item) => item.userType === userType)
    .filter((item) => plan === 'pro' || !isProRoute(item.route));
}
